import { render, staticRenderFns } from "./stall.vue?vue&type=template&id=bad75d26&scoped=true"
import script from "./stall.vue?vue&type=script&lang=js"
export * from "./stall.vue?vue&type=script&lang=js"
import style0 from "./stall.vue?vue&type=style&index=0&id=bad75d26&prod&lang=less&scoped=true"
import style1 from "./stall.vue?vue&type=style&index=1&id=bad75d26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad75d26",
  null
  
)

export default component.exports